import { render, staticRenderFns } from "./detailTabProfil.vue?vue&type=template&id=67d7f65c"
import script from "./detailTabProfil.vue?vue&type=script&lang=js"
export * from "./detailTabProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports